import { render } from "./page.vue?vue&type=template&id=4908f408&scoped=true"
const script = {}

import "./page.vue?vue&type=style&index=0&id=4908f408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4908f408"]])

export default __exports__